/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-11 09:34:48
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-03-12 16:53:33
 * @FilePath: \xjlightingdp\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import axios from 'axios';
axios.defaults.withCredentials = true

// 请求拦截器：除了登录本身，其余都加 token
axios.interceptors.request.use(config => {
  // 登录接口不加
  if (!config.url.includes('/login')) {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Token =  token
    }
  }
  return config
}, error => Promise.reject(error))

// 响应拦截器：登录成功把 token 存起来
axios.interceptors.response.use(res => {
  // 后端把 token 放在 data 里（按你们约定改）
  // console.log(res);
  if (res && res.data && res.data.data && res.data.data.token) {
    localStorage.setItem('token', res.data.data.token)
  }
  return res
}, error => {
  console.error('响应错误:', error)
  return Promise.reject(error)
})

Vue.prototype.$axios = axios

Vue.prototype.$url = 'https://www.moodsci.com/xjthunder'
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
